function formatTimeAMHHMM(timestamp) {
  // timestamp가 숫자인지 확인
  if (typeof timestamp !== "number") {
    return ""; // 유효한 timestamp가 아닌 경우 빈 문자열 반환
  }

  // timestamp를 Date 객체로 변환
  const date = new Date(timestamp);

  // Date 객체 유효성 검사
  if (isNaN(date.getTime())) {
    return ""; // 유효한 Date 객체가 아닌 경우 빈 문자열 반환
  }

  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "오후" : "오전";
  hours %= 12;
  hours = hours || 12; // 0시를 12시로 변환
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${ampm} ${hours}:${minutes}`;
}

export { formatTimeAMHHMM };
